export const CHANGE_NETWORK_STATUS = 'CHANGE_NETWORK_STATUS';

export const changeNetworkStatus = isOnline => ({
  type: CHANGE_NETWORK_STATUS,
  isOnline
});
